import React from 'react';
import { motion } from 'framer-motion';
export function Stats() {
  const stats = [{
    value: '90+',
    label: 'Arizona Cities & Towns'
  }, {
    value: '248',
    label: 'Civic Leaders Engaged'
  }, {
    value: '$1,211',
    label: 'Raised for Local Leadership'
  }, {
    value: '100%',
    label: 'Committed to Local Control'
  }];
  return <section className="bg-pac-navy py-16 border-y-4 border-pac-gold" data-id="element-192" data-mp="297mby84cyot0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193" data-mp="2dyui8vae5u1y">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-194" data-mp="2e0fcskwphczt">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center" data-id="element-195" data-mp="205d1fi93avfm" data-mpi={index}>
              <span className="font-serif text-4xl md:text-5xl font-bold text-white mb-2 drop-shadow-md" data-id="element-196" data-mp="910lfhnssxu">
                {stat.value}
              </span>
              <span className="text-sm md:text-base font-bold text-pac-gold uppercase tracking-wider" data-id="element-197" data-mp="a5vv7nata96u">
                {stat.label}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}